export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const url = process.env.VUE_APP_BASE_API;

export const credit = process.env.VUE_APP_CREDIT;